/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_VisibleInputs */

const cs_calendar_sync_visible = /** @type {(inputs: Calendar_Sync_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat tento pohled`)
};

const en_calendar_sync_visible = /** @type {(inputs: Calendar_Sync_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync this view`)
};

/**
* | output |
* | --- |
* | "Sync this view" |
*
* @param {Calendar_Sync_VisibleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_visible = /** @type {((inputs?: Calendar_Sync_VisibleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_VisibleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_visible(inputs)
	return cs_calendar_sync_visible(inputs)
});